module.exports = __webpack_public_path__ + "static/media/concert-1.small.46975cf3.jpg";